import { Divider, Stack } from '@mui/material';
import React from 'react';
import { Cart } from '../Cart/Cart';
import { MackyLogo } from '../MackyLogo/MackyLogo';
import { SearchBox } from '../SearchBox/SearchBox';

export type INavBarProps = {};

const NavBar: React.FC<INavBarProps> = ({}) => {
  return (
    <Stack sx={{
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: 100.0,
    }}
    >
      <Stack direction="row" spacing={2}>
        <MackyLogo />
        <SearchBox />
        <Cart />
      </Stack>
      <Divider />
    </Stack>
  );
};

export { NavBar };
